import tw, { styled } from "twin.macro";

export const StyledModalHearAboutUsProfileEntry = styled.div`
  ${tw`px-m flex flex-col gap-m pb-m`}
`;
